// // import { useState, useEffect } from 'react';
// // import '../ordersCard.css';
// // import { doc, updateDoc } from 'firebase/firestore';
// // import { orderDb } from '../firebaseOrders';
// // import emailjs from "emailjs-com";

// // // Initialize EmailJS once
// // emailjs.init("Vl6WUcd-dOh_FgqtW"); // Your public key

// // const AdminOrderCard = ({ order, inventoryData, orderTotal }) => {
// //   const {
// //     id,
// //     orderNumber,
// //     confirmationNumber,
// //     shippingRate,
// //     items,
// //     customerDetails,
// //     shippingAddress,
// //     billingAddress,
// //     createdAt,
// //     Status
// //   } = order;

// //   const [tracking, setTracking] = useState(order.tracking || '');
// //   const [trackingInput, setTrackingInput] = useState(order.tracking || '');
// //   const [saving, setSaving] = useState(false);
// //     const [showBut, setShowBut] = useState(false);
// //   const [reloadTrigger, setReloadTrigger] = useState(0);

// //   const formattedDate = createdAt?.toDate
// //     ? createdAt.toDate().toLocaleString()
// //     : new Date(createdAt).toLocaleString();

// //   const [openSections, setOpenSections] = useState({
// //     customerDetails: false,
// //     shippingAddress: false,
// //     billingAddress: false,
// //     items: false,
// //   });

// //   const [status, setStatus] = useState(Status);

// //   const toggleSection = (sectionName) => {
// //     setOpenSections((prev) => ({
// //       ...prev,
// //       [sectionName]: !prev[sectionName],
// //     }));
// //   };

// //   // ======================
// //   // STATUS CHANGE HANDLER
// //   // ======================
// //   const handleStatusChange = async (newStatus) => {
// //     if (status === newStatus) return; // Do nothing if status didn't change
// //     setStatus(newStatus);
// //     setSaving(true);

// //     try {
// //       // 1️⃣ Update Firestore
// //       const orderRef = doc(orderDb, "orders", id);
// //       await updateDoc(orderRef, { Status: newStatus });
// //       // console.log("Status updated in Firestore");

// //       // 2️⃣ Prepare email payload
// //       const emailPayload = {
// //         to_email: customerDetails?.email,
// //         customer_name: customerDetails?.name || "Customer",
// //         order_id: orderNumber || "N/A",
// //         new_status: newStatus,
// //         company_name: "Wear & Wonder Boutique",
// //         company_email: "info.wearandwonder@gmail.com",
// //         website_link: "https://www.wearandwonder.shop",
// //       };

// //       // Log payload for debugging
// //       // console.log("Email payload:", emailPayload);

// //       // 3️⃣ Check required fields
// //       if (!emailPayload.to_email) {
// //         console.warn("No customer email. Skipping email send.");
// //         setSaving(false);
// //         return;
// //       }

// //       // 4️⃣ Send email
// //       const emailRes = await emailjs.send(
// //         "service_q6raay6",
// //         "template_afnsb2q",
// //         emailPayload
// //       );
// //       // console.log("Status email sent:", emailRes.status, emailRes.text);

// //     } catch (error) {
// //       console.error("Error updating status or sending email:", error);
// //       alert("Failed to update status or send email. Check console for details.");
// //     } finally {
// //       setSaving(false);
// //     }
// //   };

// //   // ======================
// //   // ITEM UPDATE HANDLERS
// //   // ======================
// //   const [updatedItems, setUpdatedItems] = useState(items);

// //   const handleItemUpdate = (index, field, value) => {
// //     const newItems = [...updatedItems];
// //     newItems[index] = {
// //       ...newItems[index],
// //       [field]: isNaN(value) ? 0 : value,
// //     };
// //     setUpdatedItems(newItems);
// //   };

// //   const handleSaveItems = async () => {
// //     try {
// //       const orderRef = doc(orderDb, 'orders', id);
// //       await updateDoc(orderRef, { items: updatedItems });
// //       alert('Item updates saved!');
// //     } catch (error) {
// //       console.error('Failed to update items:', error);
// //       alert('Error saving item updates.');
// //     }
// //   };

// //   // ======================
// //   // TRACKING HANDLERS
// //   // ======================
// //   const handleSaveTracking = async () => {
// //     if (!trackingInput) return;

// //     try {
// //       const orderRef = doc(orderDb, 'orders', id);
// //       await updateDoc(orderRef, { tracking: trackingInput });
// //       setTracking(trackingInput);
// //       setTrackingInput('');
// //       setReloadTrigger(prev => prev + 1);
// //       setShowBut(true)
// //     } catch (error) {
// //       console.error('Error saving tracking number:', error);
// //       alert('Failed to save tracking number');
// //     }
// //   };

// //   const getTrackingUrl = (trackingNum) => {
// //     if (/^1Z/.test(trackingNum)) return `https://www.ups.com/track?tracknum=${trackingNum}`;
// //     if (/^\d{20,22}$/.test(trackingNum)) return `https://tools.usps.com/go/TrackConfirmAction?tLabels=${trackingNum}`;
// //     if (/^\d{12,15}$/.test(trackingNum)) return `https://www.fedex.com/fedextrack/?tracknumbers=${trackingNum}`;
// //     return `https://www.ups.com/track?tracknum=${trackingNum}`;
// //   };

// //   // ======================
// //   // RENDER
// //   // ======================
// //   return (
// //     <div className="order-card">
// //       <div className="order-header">
// //         <h6>Order #{orderNumber}</h6>
// //         <h6>Confirmation: {confirmationNumber}</h6>

// //         <div className="status-control">
// //           <label htmlFor={`status-${orderNumber}`}><strong>Status:</strong></label>
// //           <select
// //             style={{ marginLeft: 10, marginBottom: 10 }}
// //             id={`status-${orderNumber}`}
// //             value={status}
// //             onChange={(e) => handleStatusChange(e.target.value)}
// //             disabled={saving}
// //           >
// //             <option value="Received">Received</option>
// //             <option value="In Production">In Production</option>
// //             <option value="Shipped">Shipped</option>
// //           </select>
// //           {saving && <span>Saving...</span>}
// //         </div>

// //         {tracking && (
// //           <label style={{ marginTop: 25 }}>
// //             <strong>
// //               Tracking#: <a href={getTrackingUrl(tracking)} target="_blank" rel="noopener noreferrer">{tracking}</a>
// //             </strong>
// //           </label>
// //         )}

// //         {!tracking && (
// //           <div style={{ marginTop: 5 }}>
// //             <strong>Tracking#:</strong>
// //             <input
// //               style={{ marginLeft: 10 }}
// //               value={trackingInput}
// //               onChange={(e) => setTrackingInput(e.target.value)}
// //               placeholder="Tracking #"
// //             />
// //             <button onClick={handleSaveTracking} style={{ marginLeft: 10 }}>
// //               Save Tracking
// //             </button>
// //           </div>
// //         )}
// //         {showBut &&(
// //           <button style={{marginLeft:50, backgroundColor:"orange"}}>Send review request</button>
// //         )}

// //         {orderTotal && (
// //           <div className="section shipping-rate">
// //             <strong>Total:</strong> ${orderTotal}
// //           </div>
// //         )}
// //         <div className="order-date">Placed on {formattedDate}</div>
// //       </div>

// //       {/* CUSTOMER, SHIPPING, BILLING */}
// //       {[
// //         {
// //           label: 'Customer Details', key: 'customerDetails', content: (
// //             <>
// //               <p><strong>Name:</strong> {customerDetails?.name}</p>
// //               <p><strong>Email:</strong> {customerDetails?.email}</p>
// //               <p><strong>Phone:</strong> {customerDetails?.phone}</p>
// //             </>
// //           )
// //         },
// //         {
// //           label: 'Shipping Address', key: 'shippingAddress', content: (
// //             <address>
// //               {shippingAddress?.name}<br />
// //               {shippingAddress?.street1}<br />
// //               {shippingAddress?.street2 && (<>{shippingAddress.street2}<br /></>)}
// //               {shippingAddress?.city}, {shippingAddress?.state} {shippingAddress?.zip}<br />
// //               {shippingAddress?.country}
// //             </address>
// //           )
// //         },
// //         {
// //           label: 'Billing Address', key: 'billingAddress', content: (
// //             <address>
// //               {billingAddress?.name}<br />
// //               {billingAddress?.street1}<br />
// //               {billingAddress?.street2 && (<>{billingAddress.street2}<br /></>)}
// //               {billingAddress?.city}, {billingAddress?.state} {billingAddress?.zip}<br />
// //               {billingAddress?.country}
// //             </address>
// //           )
// //         },
// //       ].map(({ label, key, content }) => (
// //         <div className="section" key={key}>
// //           <h4 onClick={() => toggleSection(key)}>
// //             {label} {openSections[key] ? '▲' : '▼'}
// //           </h4>
// //           {openSections[key] && <div className="dropdown-content">{content}</div>}
// //         </div>
// //       ))}

// //       {/* ITEMS */}
//       // <div className="section">
//       //   <h4 onClick={() => toggleSection('items')}>
//       //     Items {openSections.items ? '▲' : '▼'}
//       //   </h4>
//       //   {openSections.items && (
//       //     <div className="dropdown-content">
//       //       <div className="table-wrapper">
//       //         <table className="items-table">
//       //           <thead>
//       //             <tr>
//       //               {[
//       //                 'Item', 'Image', 'File','Style', 'Color', 'Size', 'Qty', 'Price',
//       //                 'Garment Price', 'Image Price', 'Image Size', 'Inventory',
//       //                 'Actual Img $', 'Actual Garment $', 'Other $', 'Image Profit',
//       //                 'Item Profit plus $3'
//       //               ].map((h) => <th key={h}>{h}</th>)}
//       //             </tr>
//       //           </thead>
//       //           <tbody>
//       //             {updatedItems.map((item, i) => {
//       //               const id = `${item.style}-${item.colorName4API}-${item.size}`;
//       //               const inventory = inventoryData?.[id] || {};
//       //               const imagePrice = parseFloat(item.imagePrice) || 0;
//       //               const garmentPrice = parseFloat(item.garmentPrice) || 0;
//       //               const actualImagePrice = parseFloat(item.actualImagePrice) || 0;
//       //               const actualGarmentPrice = parseFloat(item.actualGarmentPrice) || 0;
//       //               const otherCost = parseFloat(item.otherCost) || 0;
//       //               const price = parseFloat(item.price) || 0;
//       //               const imageProfit = imagePrice - actualImagePrice;
//       //               const costs = actualGarmentPrice + actualImagePrice + otherCost;
//       //               const itemProfit = price - costs;

//       //               return (
//       //                 <tr key={i}>
//       //                   <td><img src={item.url} alt="" style={{ width: 80 }} /></td>
//       //                   <td><img src={item.thumImage} alt="" style={{ width: 70 }} />ID: {item.thumId}</td>
//       //                   <td><a href={item.thumFile}>URL</a></td>
//       //                   <td>{item.style}</td>
//       //                   <td>{item.color}</td>
//       //                   <td>{item.size}</td>
//       //                   <td>{item.quantity}</td>
//       //                   <td>${price.toFixed(2)}</td>
//       //                   <td>${garmentPrice.toFixed(2)}</td>
//       //                   <td>${imagePrice.toFixed(2)}</td>
//       //                   <td>{item.image_width} x {item.image_height}</td>
//       //                   <td>
//       //                     {Object.entries(inventory).map(([city, qty]) => (
//       //                       <div key={city}>{city}: {qty}</div>
//       //                     ))}
//       //                   </td>
//       //                   <td>
//       //                     <input
//       //                       type="number"
//       //                       value={actualImagePrice}
//       //                       onChange={(e) =>
//       //                         handleItemUpdate(i, 'actualImagePrice', parseFloat(e.target.value))
//       //                       }
//       //                       placeholder="Actual Img $"
//       //                       style={{ width: '80px' }}
//       //                     />
//       //                   </td>
//       //                   <td>
//       //                     <input
//       //                       type="number"
//       //                       value={actualGarmentPrice}
//       //                       onChange={(e) =>
//       //                         handleItemUpdate(i, 'actualGarmentPrice', parseFloat(e.target.value))
//       //                       }
//       //                       placeholder="Actual Garm $"
//       //                       style={{ width: '80px' }}
//       //                     />
//       //                   </td>
//       //                   <td>
//       //                     <input
//       //                       type="number"
//       //                       value={otherCost}
//       //                       onChange={(e) =>
//       //                         handleItemUpdate(i, 'otherCost', parseFloat(e.target.value))
//       //                       }
//       //                       placeholder="Other $"
//       //                       style={{ width: '80px' }}
//       //                     />
//       //                   </td>
//       //                   <td>${imageProfit.toFixed(2)}</td>
//       //                   <td>${itemProfit.toFixed(2)}</td>
//       //                 </tr>
//       //               );
//       //             })}
//       //           </tbody>
//       //         </table>
//       //         <button onClick={handleSaveItems} style={{ marginTop: '1rem' }}>
//       //           Save Item Updates
//       //         </button>
//       //       </div>
//       //     </div>
//       //   )}
//       // </div>

// //       <div className="section shipping-rate">
// //         <strong>Shipping Rate:</strong> ${parseFloat(shippingRate).toFixed(2)}
// //       </div>
// //     </div>
// //   );
// // };

// // export default AdminOrderCard;
// import { useState, useEffect } from 'react';
// import '../ordersCard.css';
// import { doc, updateDoc } from 'firebase/firestore';
// import { orderDb } from '../firebaseOrders';
// import emailjs from "emailjs-com";

// // Initialize EmailJS once
// emailjs.init("Vl6WUcd-dOh_FgqtW"); // Your public key

// const AdminOrderCard = ({ order, inventoryData, orderTotal }) => {
//   const {
//     id,
//     orderNumber,
//     confirmationNumber,
//     shippingRate,
//     items,
//     customerDetails,
//     shippingAddress,
//     billingAddress,
//     createdAt,
//     Status
//   } = order;

//   const [tracking, setTracking] = useState(order.tracking || '');
//   const [trackingInput, setTrackingInput] = useState(order.tracking || '');
//   const [saving, setSaving] = useState(false);
//   const [showBut, setShowBut] = useState(false);
//   const [reloadTrigger, setReloadTrigger] = useState(0);

//   const formattedDate = createdAt?.toDate
//     ? createdAt.toDate().toLocaleString()
//     : new Date(createdAt).toLocaleString();

//   const [openSections, setOpenSections] = useState({
//     customerDetails: false,
//     shippingAddress: false,
//     billingAddress: false,
//     items: false,
//   });

//   const [status, setStatus] = useState(Status);

//   const toggleSection = (sectionName) => {
//     setOpenSections((prev) => ({
//       ...prev,
//       [sectionName]: !prev[sectionName],
//     }));
//   };

//   // ======================
//   // STATUS CHANGE HANDLER
//   // ======================
//   const handleStatusChange = async (newStatus) => {
//     if (status === newStatus) return; // Do nothing if status didn't change
//     setStatus(newStatus);
//     setSaving(true);

//     try {
//       // 1️⃣ Update Firestore
//       const orderRef = doc(orderDb, "orders", id);
//       await updateDoc(orderRef, { Status: newStatus });

//       // 2️⃣ Prepare email payload
//       const emailPayload = {
//         to_email: customerDetails?.email,
//         customer_name: customerDetails?.name || "Customer",
//         order_id: orderNumber || "N/A",
//         new_status: newStatus,
//         company_name: "Wear & Wonder Boutique",
//         company_email: "info.wearandwonder@gmail.com",
//         website_link: "https://www.wearandwonder.shop",
//       };

//       if (!emailPayload.to_email) {
//         console.warn("No customer email. Skipping email send.");
//         setSaving(false);
//         return;
//       }

//       // 3️⃣ Send status email
//       await emailjs.send(
//         "service_q6raay6",
//         "template_afnsb2q",
//         emailPayload
//       );

//     } catch (error) {
//       console.error("Error updating status or sending email:", error);
//       alert("Failed to update status or send email. Check console for details.");
//     } finally {
//       setSaving(false);
//     }
//   };

//   // ======================
//   // ITEM UPDATE HANDLERS
//   // ======================
//   const [updatedItems, setUpdatedItems] = useState(items);

//   const handleItemUpdate = (index, field, value) => {
//     const newItems = [...updatedItems];
//     newItems[index] = {
//       ...newItems[index],
//       [field]: isNaN(value) ? 0 : value,
//     };
//     setUpdatedItems(newItems);
//   };

//   const handleSaveItems = async () => {
//     try {
//       const orderRef = doc(orderDb, 'orders', id);
//       await updateDoc(orderRef, { items: updatedItems });
//       alert('Item updates saved!');
//     } catch (error) {
//       console.error('Failed to update items:', error);
//       alert('Error saving item updates.');
//     }
//   };

//   // ======================
//   // TRACKING HANDLERS
//   // ======================
//   const handleSaveTracking = async () => {
//     if (!trackingInput) return;

//     try {
//       const orderRef = doc(orderDb, 'orders', id);
//       await updateDoc(orderRef, { tracking: trackingInput });
//       setTracking(trackingInput);
//       setTrackingInput('');
//       setReloadTrigger(prev => prev + 1);
//       setShowBut(true);
//     } catch (error) {
//       console.error('Error saving tracking number:', error);
//       alert('Failed to save tracking number');
//     }
//   };

//   const getTrackingUrl = (trackingNum) => {
//     if (/^1Z/.test(trackingNum)) return `https://www.ups.com/track?tracknum=${trackingNum}`;
//     if (/^\d{20,22}$/.test(trackingNum)) return `https://tools.usps.com/go/TrackConfirmAction?tLabels=${trackingNum}`;
//     if (/^\d{12,15}$/.test(trackingNum)) return `https://www.fedex.com/fedextrack/?tracknumbers=${trackingNum}`;
//     return `https://www.ups.com/track?tracknum=${trackingNum}`;
//   };

//   // ======================
//   // FEEDBACK EMAIL HANDLER
//   // ======================
//   const handleSendFeedbackEmail = async () => {
//     if (!customerDetails?.email) {
//       alert("Customer email is missing.");
//       return;
//     }

//     try {
//       const feedbackPayload = {
//         to_email: customerDetails.email,
//         customer_name: customerDetails.name || "Customer",
//         order_id: orderNumber,
//         website_link: "https://www.wearandwonder.shop",
//       };

//       // 🔹 Replace these with your actual service/template IDs later
//       await emailjs.send(
//         "service_s7lno47",
//         "template_0nsva6b",
//         feedbackPayload,
//         "rdqiUE27ZZhdCxKfb"
//       );

//       alert("Feedback request email sent!");
//     } catch (error) {
//       console.error("Failed to send feedback email:", error);
//       alert("Failed to send feedback email.");
//     }
//   };

//   // ======================
//   // RENDER
//   // ======================
//   return (
//     <div className="order-card">
//       <div className="order-header">
//         <h6>Order #{orderNumber}</h6>
//         <h6>Confirmation: {confirmationNumber}</h6>

//         <div className="status-control">
//           <label htmlFor={`status-${orderNumber}`}><strong>Status:</strong></label>
//           <select
//             style={{ marginLeft: 10, marginBottom: 10 }}
//             id={`status-${orderNumber}`}
//             value={status}
//             onChange={(e) => handleStatusChange(e.target.value)}
//             disabled={saving}
//           >
//             <option value="Received">Received</option>
//             <option value="In Production">In Production</option>
//             <option value="Shipped">Shipped</option>
//           </select>
//           {saving && <span>Saving...</span>}
//         </div>

//         {tracking && (
//           <label style={{ marginTop: 25 }}>
//             <strong>
//               Tracking#: <a href={getTrackingUrl(tracking)} target="_blank" rel="noopener noreferrer">{tracking}</a>
//             </strong>
//           </label>
//         )}

//         {!tracking && (
//           <div style={{ marginTop: 5 ,width:"100%"}}>
//             <strong>Tracking#:</strong>
//             <input
//               style={{ marginLeft: 10 }}
//               value={trackingInput}
//               onChange={(e) => setTrackingInput(e.target.value)}
//               placeholder="Tracking #"
//             />
//             <button onClick={handleSaveTracking} style={{ marginLeft: 10 }}>
//               Save Tracking
//             </button>
//           </div>
//         )}

//         {/* 🔶 Feedback Button */}
//         {tracking && showBut && (
//           <button
//             onClick={handleSendFeedbackEmail}
//             style={{
//               marginLeft: 30,
//               marginTop: 20,
//               backgroundColor: "orange",
//               color: "#fff",
//               padding: "8px 16px",
//               border: "none",
//               borderRadius: 4,
//               cursor: "pointer"
//             }}
//           >
//             Feedback Request
//           </button>
//         )}

//         {orderTotal && (
//           <div className="section shipping-rate">
//             <strong>Total:</strong> ${orderTotal}
//           </div>
//         )}
//         <div className="order-date">Placed on {formattedDate}</div>
//       </div>

//       {/* CUSTOMER, SHIPPING, BILLING */}
//       {[ /* ... rest of your sections ... */ ].map(({ label, key, content }) => (
//         <div className="section" key={key}>
//           <h4 onClick={() => toggleSection(key)}>
//             {label} {openSections[key] ? '▲' : '▼'}
//           </h4>
//           {openSections[key] && <div className="dropdown-content">{content}</div>}
//         </div>
//       ))}

//       {/* ITEMS section remains unchanged */}

//       <div className="section">
//         <h4 onClick={() => toggleSection('items')}>
//           Items {openSections.items ? '▲' : '▼'}
//         </h4>
//         {openSections.items && (
//           <div className="dropdown-content">
//             <div className="table-wrapper">
//               <table className="items-table">
//                 <thead>
//                   <tr>
//                     {[
//                       'Item', 'Image', 'File','Style', 'Color', 'Size', 'Qty', 'Price',
//                       'Garment Price', 'Image Price', 'Image Size', 'Inventory',
//                       'Actual Img $', 'Actual Garment $', 'Other $', 'Image Profit',
//                       'Item Profit plus $3'
//                     ].map((h) => <th key={h}>{h}</th>)}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {updatedItems.map((item, i) => {
//                     const id = `${item.style}-${item.colorName4API}-${item.size}`;
//                     const inventory = inventoryData?.[id] || {};
//                     const imagePrice = parseFloat(item.imagePrice) || 0;
//                     const garmentPrice = parseFloat(item.garmentPrice) || 0;
//                     const actualImagePrice = parseFloat(item.actualImagePrice) || 0;
//                     const actualGarmentPrice = parseFloat(item.actualGarmentPrice) || 0;
//                     const otherCost = parseFloat(item.otherCost) || 0;
//                     const price = parseFloat(item.price) || 0;
//                     const imageProfit = imagePrice - actualImagePrice;
//                     const costs = actualGarmentPrice + actualImagePrice + otherCost;
//                     const itemProfit = price - costs;

//                     return (
//                       <tr key={i}>
//                         <td><img src={item.url} alt="" style={{ width: 80 }} /></td>
//                         <td><img src={item.thumImage} alt="" style={{ width: 70 }} />ID: {item.thumId}</td>
//                         <td><a href={item.thumFile}>URL</a></td>
//                         <td>{item.style}</td>
//                         <td>{item.color}</td>
//                         <td>{item.size}</td>
//                         <td>{item.quantity}</td>
//                         <td>${price.toFixed(2)}</td>
//                         <td>${garmentPrice.toFixed(2)}</td>
//                         <td>${imagePrice.toFixed(2)}</td>
//                         <td>{item.image_width} x {item.image_height}</td>
//                         <td>
//                           {Object.entries(inventory).map(([city, qty]) => (
//                             <div key={city}>{city}: {qty}</div>
//                           ))}
//                         </td>
//                         <td>
//                           <input
//                             type="number"
//                             value={actualImagePrice}
//                             onChange={(e) =>
//                               handleItemUpdate(i, 'actualImagePrice', parseFloat(e.target.value))
//                             }
//                             placeholder="Actual Img $"
//                             style={{ width: '80px' }}
//                           />
//                         </td>
//                         <td>
//                           <input
//                             type="number"
//                             value={actualGarmentPrice}
//                             onChange={(e) =>
//                               handleItemUpdate(i, 'actualGarmentPrice', parseFloat(e.target.value))
//                             }
//                             placeholder="Actual Garm $"
//                             style={{ width: '80px' }}
//                           />
//                         </td>
//                         <td>
//                           <input
//                             type="number"
//                             value={otherCost}
//                             onChange={(e) =>
//                               handleItemUpdate(i, 'otherCost', parseFloat(e.target.value))
//                             }
//                             placeholder="Other $"
//                             style={{ width: '80px' }}
//                           />
//                         </td>
//                         <td>${imageProfit.toFixed(2)}</td>
//                         <td>${itemProfit.toFixed(2)}</td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//               <button onClick={handleSaveItems} style={{ marginTop: '1rem' }}>
//                 Save Item Updates
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//       <div className="section shipping-rate">
//         <strong>Shipping Rate:</strong> ${parseFloat(shippingRate).toFixed(2)}
//       </div>
//     </div>
//   );
// };

// export default AdminOrderCard;
import { useState } from 'react';
import '../ordersCard.css';
import { doc, updateDoc } from 'firebase/firestore';
import { orderDb } from '../firebaseOrders';
import emailjs from "emailjs-com";

// ---------------------------
//  STATUS EMAIL PUBLIC KEY
// ---------------------------
const STATUS_EMAIL_PUBLIC_KEY = "Vl6WUcd-dOh_FgqtW";  // ✔ Correct for status email

// ---------------------------
//  FEEDBACK EMAIL PUBLIC KEY
// ---------------------------
const FEEDBACK_EMAIL_PUBLIC_KEY = "rdqiUE27ZZhdCxKfb"; // ✔ Correct for feedback email

const AdminOrderCard = ({ order, inventoryData, orderTotal }) => {
  const {
    id,
    orderNumber,
    confirmationNumber,
    shippingRate,
    items,
    customerDetails,
    shippingAddress,
    billingAddress,
    createdAt,
    Status,
    feedbackRequested // ✅ New field from Firestore
  } = order;

  const [tracking, setTracking] = useState(order.tracking || '');
  const [trackingInput, setTrackingInput] = useState(order.tracking || '');
  const [saving, setSaving] = useState(false);
  const [feedbackSent, setFeedbackSent] = useState(feedbackRequested || false); // initialize from DB

  const formattedDate = createdAt?.toDate
    ? createdAt.toDate().toLocaleString()
    : new Date(createdAt).toLocaleString();

  const [openSections, setOpenSections] = useState({
    customerDetails: false,
    shippingAddress: false,
    billingAddress: false,
    items: false,
  });

  const [status, setStatus] = useState(Status);
  const [updatedItems, setUpdatedItems] = useState(items);

  const toggleSection = (sectionName) => {
    setOpenSections((prev) => ({
      ...prev,
      [sectionName]: !prev[sectionName],
    }));
  };

  // ============================
  // ⭐ STATUS CHANGE HANDLER
  // ============================
  const handleStatusChange = async (newStatus) => {
    if (status === newStatus) return;
    setStatus(newStatus);
    setSaving(true);

    try {
      const orderRef = doc(orderDb, "orders", id);
      await updateDoc(orderRef, { Status: newStatus });

      const emailPayload = {
        to_email: customerDetails?.email,
        customer_name: customerDetails?.name || "Customer",
        order_id: orderNumber,
        new_status: newStatus,
        company_name: "Wear & Wonder Boutique",
        company_email: "info.wearandwonder@gmail.com",
        website_link: "https://www.wearandwonder.shop",
      };

      await emailjs.send(
        "service_q6raay6",
        "template_afnsb2q",
        emailPayload,
        STATUS_EMAIL_PUBLIC_KEY
      );
    } catch (error) {
      console.error("Status update or email error:", error);
      alert("Failed to update status or send email.");
    } finally {
      setSaving(false);
    }
  };

  // ============================
  // ⭐ ITEM UPDATE HANDLERS
  // ============================
  const handleItemUpdate = (index, field, value) => {
    const newItems = [...updatedItems];
    newItems[index] = {
      ...newItems[index],
      [field]: isNaN(value) ? 0 : value,
    };
    setUpdatedItems(newItems);
  };

  const handleSaveItems = async () => {
    try {
      const orderRef = doc(orderDb, 'orders', id);
      await updateDoc(orderRef, { items: updatedItems });
      alert('Item updates saved!');
    } catch (error) {
      console.error('Failed to update items:', error);
      alert('Error saving item updates.');
    }
  };

  // ============================
  // ⭐ TRACKING HANDLER
  // ============================
  const handleSaveTracking = async () => {
    if (!trackingInput) return;

    try {
      const orderRef = doc(orderDb, 'orders', id);
      await updateDoc(orderRef, { tracking: trackingInput });
      setTracking(trackingInput);
      setTrackingInput('');
    } catch (error) {
      console.error('Error saving tracking:', error);
      alert('Failed to save tracking number');
    }
  };

  const getTrackingUrl = (trackingNum) => {
    if (/^1Z/.test(trackingNum)) return `https://www.ups.com/track?tracknum=${trackingNum}`;
    if (/^\d{20,22}$/.test(trackingNum)) return `https://tools.usps.com/go/TrackConfirmAction?tLabels=${trackingNum}`;
    if (/^\d{12,15}$/.test(trackingNum)) return `https://www.fedex.com/fedextrack/?tracknumbers=${trackingNum}`;
    return `https://www.ups.com/track?tracknum=${trackingNum}`;
  };

  // ============================
  // ⭐ FEEDBACK EMAIL HANDLER
  // ============================
  const handleSendFeedbackEmail = async () => {
    if (!customerDetails?.email) {
      alert("Customer email missing.");
      return;
    }

    try {
      const feedbackPayload = {
        to_email: customerDetails.email,
        customer_name: customerDetails.name || "Customer",
        order_id: orderNumber,
        website_link: "https://www.wearandwonder.shop",
      };

      await emailjs.send(
        "service_s7lno47",
        "template_0nsva6b",
        feedbackPayload,
        FEEDBACK_EMAIL_PUBLIC_KEY
      );

      // ✅ Update Firestore so button won't appear again
      const orderRef = doc(orderDb, "orders", id);
      await updateDoc(orderRef, { feedbackRequested: true });

      setFeedbackSent(true);
    } catch (error) {
      console.error("Feedback email error:", error);
      alert("Failed to send feedback email.");
    }
  };

  // ============================
  // ⭐ RENDER
  // ============================
  return (
    <div className="order-card">
      <div className="order-header">
        <h6>Order #{orderNumber}</h6>
        <h6>Confirmation: {confirmationNumber}</h6>

        {/* STATUS SELECT */}
        <div className="status-control">
          <label><strong>Status:</strong></label>
          <select
            style={{ marginLeft: 10 }}
            value={status}
            onChange={(e) => handleStatusChange(e.target.value)}
            disabled={saving}
          >
            <option value="Received">Received</option>
            <option value="In Production">In Production</option>
            <option value="Shipped">Shipped</option>
            <option value="Delivered">Delivered</option>
          </select>
          {saving && <span>Saving...</span>}
        </div>

        {/* TRACKING */}
        {tracking ? (
          <label style={{ marginTop: 20 }}>
            <strong>
              Tracking#: <a href={getTrackingUrl(tracking)} target="_blank" rel="noopener noreferrer">{tracking}</a>
            </strong>
          </label>
        ) : (
          <div style={{ marginTop: 5 }}>
            <strong>Tracking#:</strong>
            <input
              style={{ marginLeft: 10 }}
              value={trackingInput}
              onChange={(e) => setTrackingInput(e.target.value)}
              placeholder="Tracking #"
            />
            <button onClick={handleSaveTracking} style={{ marginLeft: 10 }}>
              Save Tracking
            </button>
          </div>
        )}

        {/* FEEDBACK BUTTON / SENT MESSAGE */}
        {status === "Shipped" && tracking && (
          <>
            {!feedbackSent ? (
              <button
                onClick={handleSendFeedbackEmail}
                style={{
                  marginLeft: 20,
                  marginTop: 15,
                  backgroundColor: "orange",
                  color: "white",
                  padding: "8px 16px",
                  borderRadius: 4,
                  border: "none",
                  cursor: "pointer"
                }}
              >
                Feedback Request
              </button>
            ) : (
              <p style={{ marginLeft: 20, marginTop: 15, fontWeight: "bold", color: "green" }}>
                Feedback request sent
              </p>
            )}
          </>
        )}

        {/* TOTAL */}
        {orderTotal && (
          <div className="section shipping-rate">
            <strong>Total:</strong> ${orderTotal}
          </div>
        )}

        <div className="order-date">Placed on {formattedDate}</div>
      </div>

      {/* ITEMS */}
      <div className="section">
        <h4 onClick={() => toggleSection('items')}>
          Items {openSections.items ? '▲' : '▼'}
        </h4>

        {openSections.items && (
          <div className="dropdown-content">
            <div className="table-wrapper">
              <table className="items-table">
                <thead>
                  <tr>
                    {[
                      'Item', 'Image', 'File', 'Style', 'Color', 'Size',
                      'Qty', 'Price', 'Garment Price', 'Image Price',
                      'Image Size', 'Inventory', 'Actual Img $',
                      'Actual Garment $', 'Other $', 'Image Profit',
                      'Item Profit + $3'
                    ].map((h) => <th key={h}>{h}</th>)}
                  </tr>
                </thead>
                <tbody>
                  {updatedItems.map((item, i) => {
                    const id = `${item.style}-${item.colorName4API}-${item.size}`;
                    const inventory = inventoryData?.[id] || {};

                    const imagePrice = parseFloat(item.imagePrice) || 0;
                    const garmentPrice = parseFloat(item.garmentPrice) || 0;
                    const actualImagePrice = parseFloat(item.actualImagePrice) || 0;
                    const actualGarmentPrice = parseFloat(item.actualGarmentPrice) || 0;
                    const otherCost = parseFloat(item.otherCost) || 0;
                    const price = parseFloat(item.price) || 0;

                    const imageProfit = imagePrice - actualImagePrice;
                    const costs = actualGarmentPrice + actualImagePrice + otherCost;
                    const itemProfit = price - costs;

                    return (
                      <tr key={i}>
                        <td><img src={item.url} style={{ width: 80 }} /></td>
                        <td><img src={item.thumImage} style={{ width: 70 }} />ID: {item.thumId}</td>
                        <td><a href={item.thumFile}>URL</a></td>
                        <td>{item.style}</td>
                        <td>{item.color}</td>
                        <td>{item.size}</td>
                        <td>{item.quantity}</td>
                        <td>${price.toFixed(2)}</td>
                        <td>${garmentPrice.toFixed(2)}</td>
                        <td>${imagePrice.toFixed(2)}</td>
                        <td>{item.image_width} x {item.image_height}</td>
                        <td>
                          {Object.entries(inventory).map(([city, qty]) => (
                            <div key={city}>{city}: {qty}</div>
                          ))}
                        </td>
                        <td>
                          <input
                            type="number"
                            value={actualImagePrice}
                            onChange={(e) =>
                              handleItemUpdate(i, 'actualImagePrice', parseFloat(e.target.value))
                            }
                            style={{ width: 80 }}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            value={actualGarmentPrice}
                            onChange={(e) =>
                              handleItemUpdate(i, 'actualGarmentPrice', parseFloat(e.target.value))
                            }
                            style={{ width: 80 }}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            value={otherCost}
                            onChange={(e) =>
                              handleItemUpdate(i, 'otherCost', parseFloat(e.target.value))
                            }
                            style={{ width: 80 }}
                          />
                        </td>
                        <td>${imageProfit.toFixed(2)}</td>
                        <td>${itemProfit.toFixed(2)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              <button onClick={handleSaveItems} style={{ marginTop: 20 }}>
                Save Item Updates
              </button>
            </div>
          </div>
        )}
      </div>

      <div className="section shipping-rate">
        <strong>Shipping Rate:</strong> ${parseFloat(shippingRate).toFixed(2)}
      </div>
    </div>
  );
};

export default AdminOrderCard;

